"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.queryToLocations = void 0;
var _mapValues2 = _interopRequireDefault(require("lodash/mapValues"));
var _localityType = _interopRequireDefault(require("../enums/locality-type"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var _mapValues = (0, _mapValues2.default)(_localityType.default, each => each.type),
  REGION = _mapValues.REGION,
  DISTRICT = _mapValues.DISTRICT,
  DIVISION = _mapValues.DIVISION,
  POSTCODE = _mapValues.POSTCODE,
  STREET = _mapValues.STREET;
var queryToLocations = query => {
  var result = query.filters.getLocalities(REGION).map(each => {
    var _each$metaData;
    return {
      state: (_each$metaData = each.metaData) === null || _each$metaData === void 0 ? void 0 : _each$metaData.state,
      region: each.name
    };
  });
  result = result.concat(query.filters.getLocalities(DISTRICT).map(each => {
    var _each$metaData2, _each$parent;
    return {
      state: (_each$metaData2 = each.metaData) === null || _each$metaData2 === void 0 ? void 0 : _each$metaData2.state,
      region: (_each$parent = each.parent) === null || _each$parent === void 0 ? void 0 : _each$parent.name,
      area: each.name
    };
  }));
  result = result.concat(query.filters.getLocalities(POSTCODE).map(each => {
    var _each$metaData3, _each$parent2, _each$parent2$parent, _each$parent3;
    return {
      state: (_each$metaData3 = each.metaData) === null || _each$metaData3 === void 0 ? void 0 : _each$metaData3.state,
      region: (_each$parent2 = each.parent) === null || _each$parent2 === void 0 ? void 0 : (_each$parent2$parent = _each$parent2.parent) === null || _each$parent2$parent === void 0 ? void 0 : _each$parent2$parent.name,
      area: (_each$parent3 = each.parent) === null || _each$parent3 === void 0 ? void 0 : _each$parent3.name,
      postcode: each.id.toString()
    };
  }));
  result = result.concat(query.filters.getLocalities(DIVISION).map(each => {
    var _each$metaData4, _each$parent4, _each$parent4$parent, _each$parent5, _each$metaData5;
    return {
      state: (_each$metaData4 = each.metaData) === null || _each$metaData4 === void 0 ? void 0 : _each$metaData4.state,
      region: (_each$parent4 = each.parent) === null || _each$parent4 === void 0 ? void 0 : (_each$parent4$parent = _each$parent4.parent) === null || _each$parent4$parent === void 0 ? void 0 : _each$parent4$parent.name,
      area: (_each$parent5 = each.parent) === null || _each$parent5 === void 0 ? void 0 : _each$parent5.name,
      suburb: each.name,
      postcode: (_each$metaData5 = each.metaData) === null || _each$metaData5 === void 0 ? void 0 : _each$metaData5.postcode
    };
  }));
  result = result.concat(query.filters.getLocalities(STREET).map(each => {
    var _each$metaData6, _each$parent6, _each$parent6$parent, _each$parent6$parent$, _each$parent7, _each$parent7$parent, _each$parent8, _each$metaData7;
    return {
      state: (_each$metaData6 = each.metaData) === null || _each$metaData6 === void 0 ? void 0 : _each$metaData6.state,
      region: (_each$parent6 = each.parent) === null || _each$parent6 === void 0 ? void 0 : (_each$parent6$parent = _each$parent6.parent) === null || _each$parent6$parent === void 0 ? void 0 : (_each$parent6$parent$ = _each$parent6$parent.parent) === null || _each$parent6$parent$ === void 0 ? void 0 : _each$parent6$parent$.name,
      area: (_each$parent7 = each.parent) === null || _each$parent7 === void 0 ? void 0 : (_each$parent7$parent = _each$parent7.parent) === null || _each$parent7$parent === void 0 ? void 0 : _each$parent7$parent.name,
      suburb: (_each$parent8 = each.parent) === null || _each$parent8 === void 0 ? void 0 : _each$parent8.name,
      postcode: (_each$metaData7 = each.metaData) === null || _each$metaData7 === void 0 ? void 0 : _each$metaData7.postcode,
      street: each.name
    };
  }));
  return result;
};
exports.queryToLocations = queryToLocations;